import {useEffect, useState} from 'react';

import {CreationAttribute} from 'src/modules/event-create/typedefs';
import {getDecorationTemplates} from 'src/openapi/apis/AttributeTemplateControllerApi';
import {DecorationType} from 'src/openapi/models/DecorationType';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {UserEventSource} from 'src/openapi/models/UserEventSource';
import {useAppDispatch} from 'src/store';

export const useDecorationTemplates = (
    eventSave: EventChangeRequest,
    decorationType: DecorationType | null | undefined,
): CreationAttribute[] => {
    const dispatch = useAppDispatch();
    const [decorationTemplate, setDecorationTemplate] = useState<CreationAttribute[]>([]);

    useEffect(() => {
        const source = eventSave.source as unknown as UserEventSource;

        if (decorationType && source) {
            const fetchData = async () => {
                const response = await dispatch(getDecorationTemplates({source, decorationType}));

                if (response.payload.success) {
                    const attributesTemplate = response.payload.data;
                    setDecorationTemplate(attributesTemplate);
                }
            };
            fetchData();
        }
    }, [decorationType, dispatch, eventSave.source]);

    return decorationTemplate;
};
